<template>
    <div>
<!--hero section start-->

<section class="banner-2 pos-r">
   <div id="particles-js"></div>
  <div class="container">
    <div class="row align-items-center">
      <div class="col">
        <h5 class="d-inline-block text-theme px-3 py-2 white-bg box-shadow">Let Work Flow</h5>
        <h1 class="bnr-title2 mb-0 mt-3">Multiply Your Agency Bussiness</h1>
      </div>
    </div>
  </div>
</section>

<!--hero section end-->
<!--body content start-->

<div id="main-page" class="page-content">

<!--client start-->

<section class="p-0">
  <div class="container-fluid pl-0">
    <div class="row">
      <div class="col-lg-8 col-md-10 col-11 mr-auto text-center dark-bg p-3 p-md-5">
        <div class="owl-carousel owl-theme no-pb" data-dots="false" data-items="4" data-md-items="3" data-sm-items="3" data-margin="20" data-autoplay="true">
          <div class="item">
            <img class="img-fluid" src="images/client/01.png" alt="">
          </div>
          <div class="item">
            <img class="img-fluid" src="images/client/02.png" alt="">
          </div>
          <div class="item">
            <img class="img-fluid" src="images/client/03.png" alt="">
          </div>
          <div class="item">
            <img class="img-fluid" src="images/client/04.png" alt="">
          </div>
          <div class="item">
            <img class="img-fluid" src="images/client/05.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--client end-->


<!--case study start-->

<section class="theme-bg pos-r parallaxie" data-bg-img="images/pattern/01.png">
  <div class="container-fluid px-lg-5">
    <div class="row">
      <div class="col-12">
        <div class="cases-slider pos-r">
          <div class="row">
            <div class="col-md-11 col-12">
              <div class="owl-carousel no-pb" data-items="1" data-autoplay="true">
                <div class="item">
                  <div class="cases-item style-2">
                    <div class="cases-images js-tilt" data-tilt-perspective="1000" data-tilt-speed="500" data-tilt-max="15">
                      <img class="img-fluid" src="images/cases/01.jpg" alt="">
                    </div>
                    <div class="cases-desc">
                      <div> <span>Design</span>
                        <h3 class="text-white">Experience for Agency</h3>
                        <p class="text-light">Agencio discovering the source behind the ubiquitous filler</p>
                      </div> <a class="btn btn-white btn-sm" href="case-studies-single.html">Read Case Study <i class="fas fa-plus-square ml-2"></i></a>
                    </div>
                  </div>
                </div>
                <div class="item">
                  <div class="cases-item style-2">
                    <div class="cases-images js-tilt" data-tilt-perspective="1000" data-tilt-speed="500" data-tilt-max="15">
                      <img class="img-fluid" src="images/cases/02.jpg" alt="">
                    </div>
                    <div class="cases-desc">
                      <div> <span>UX/UI Design</span>
                        <h3 class="text-white">Crafted with Love</h3>
                        <p class="text-light">Agencio discovering the source behind the ubiquitous filler</p>
                      </div> <a class="btn btn-white btn-sm" href="case-studies-single.html">Read Case Study <i class="fas fa-plus-square ml-2"></i></a>
                    </div>
                  </div>
                </div>
                <div class="item">
                  <div class="cases-item style-2">
                    <div class="cases-images js-tilt" data-tilt-perspective="1000" data-tilt-speed="500" data-tilt-max="15">
                      <img class="img-fluid" src="images/cases/03.jpg" alt="">
                    </div>
                    <div class="cases-desc">
                      <div> <span>Branding</span>
                        <h3 class="text-white">Colibri Identity</h3>
                        <p class="text-light">Agencio discovering the source behind the ubiquitous filler</p>
                      </div> <a class="btn btn-white btn-sm" href="case-studies-single.html">Read Case Study <i class="fas fa-plus-square ml-2"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--case study end-->


<!--service start-->

<section class="pos-r">
  <div class="container">
    <div class="row align-items-end mb-5">
      <div class="col-lg-6 col-12">
        <div class="section-title mb-0">
          <h6>What We Offer</h6>
          <h2 class="title mb-0">Building Brands More Quickly</h2>
        </div>
      </div>
      <div class="col-lg-6 col-12 md-mt-5">
        <p class="lead text-black font-w-5 mb-0">Agencio discovering the source behind the ubiquitous filler text In seeing a sample of lorem ipsum, his interest was piqued by consectetur Agencio discovering</p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-md-6">
        <div class="featured-item style-3">
          <div class="featured-icon"> <i class="flaticon-ui"></i>
            <span class="border-anim"></span>
          </div>
          <div class="featured-title">
            <h5>UX Design</h5>
          </div>
          <div class="featured-desc">
            <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
            <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
          </div>          
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mt-5">
        <div class="featured-item style-3 active">
          <div class="featured-icon"> <i class="flaticon-analysis"></i>
            <span class="border-anim"></span>
          </div>
          <div class="featured-title">
            <h5>Development</h5>
          </div>
          <div class="featured-desc">
            <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
            <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mt-5">
        <div class="featured-item style-3">
          <div class="featured-icon"> <i class="flaticon-challenges"></i>
            <span class="border-anim"></span>
          </div>
          <div class="featured-title">
            <h5>Strategy</h5>
          </div>
          <div class="featured-desc">
            <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
            <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="featured-item style-3">
          <div class="featured-icon"> <i class="flaticon-idea"></i>
            <span class="border-anim"></span>
          </div>
          <div class="featured-title">
            <h5>Web Design</h5>
          </div>
          <div class="featured-desc">
            <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
            <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mt-5">
        <div class="featured-item style-3">
          <div class="featured-icon"> <i class="flaticon-optimization"></i>
            <span class="border-anim"></span>
          </div>
          <div class="featured-title">
            <h5>Optimization</h5>
          </div>
          <div class="featured-desc">
            <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
            <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mt-5">
        <div class="featured-item style-3">
          <div class="featured-icon"> <i class="flaticon-support"></i>
            <span class="border-anim"></span>
          </div>
          <div class="featured-title">
            <h5>24/7 Support</h5>
          </div>
          <div class="featured-desc">
            <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
            <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--service end-->


<!--counter start-->

<section class="dark-bg parallaxie" data-bg-img="images/pattern/01.png">
  <div class="container">
    <div class="row">
      <div class="col-lg-3 col-sm-6">
        <div class="counter">
          <div class="d-flex align-items-center">
            <div class="counter-icon ml-3"> <i class="flaticon-suitcase"></i>
            </div> <span class="count-number" data-to="900" data-speed="4000">900</span>
          </div>
          <h6>Lot's Of Work Completed</h6>
        </div>
      </div>
      <div class="col-lg-3 col-sm-6 mt-5 mt-sm-0">
        <div class="counter">
          <div class="d-flex align-items-center">
            <div class="counter-icon ml-3"> <i class="flaticon-experience"></i>
            </div> <span class="count-number" data-to="20" data-speed="4000">20</span>
          </div>
          <h6>Years of Experience</h6>
        </div>
      </div>
      <div class="col-lg-3 col-sm-6 mt-5 mt-lg-0">
        <div class="counter">
          <div class="d-flex align-items-center">
            <div class="counter-icon ml-3"> <i class="flaticon-trophy"></i>
            </div> <span class="count-number" data-to="400" data-speed="4000">400</span>
          </div>
          <h6>Best Awards Winning</h6>
        </div>
      </div>
      <div class="col-lg-3 col-sm-6 mt-5 mt-lg-0">
        <div class="counter">
          <div class="d-flex align-items-center">
            <div class="counter-icon ml-3"> <i class="flaticon-rating"></i>
            </div> <span class="count-number" data-to="950" data-speed="4000">950</span>
          </div>
          <h6>Reviews from clients</h6>
        </div>
      </div>
    </div>
  </div>
</section>

<!--counter end-->


<!--team start-->

<section>
  <div class="container">
    <div class="row justify-content-center text-center">
      <div class="col-lg-8 col-12">
        <div class="section-title">
          <h6>Expert Team</h6>
          <h2 class="title mb-0">Meet Our Expert will ready for your service</h2>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-12">
        <div class="team-member style-2">
          <div class="team-images">
            <img class="img-fluid box-shadow" src="images/team/01.jpg" alt="">
          </div>
          <div class="team-social-icon">
            <ul>
              <li><a href="#"><i class="fab fa-facebook-f"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-google-plus-g"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-linkedin-in"></i></a>
              </li>
            </ul>
          </div>
          <div class="team-description">
            <h5><a href="team-single.html">Jesson Mart</a></h5>
            <span>Advisor</span>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-12 mt-5 mt-md-0">
        <div class="team-member style-2">
          <div class="team-images">
            <img class="img-fluid box-shadow" src="images/team/02.jpg" alt="">
          </div>
          <div class="team-social-icon">
            <ul>
              <li><a href="#"><i class="fab fa-facebook-f"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-google-plus-g"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-linkedin-in"></i></a>
              </li>
            </ul>
          </div>
          <div class="team-description">
            <h5><a href="team-single.html">Michael Vegas</a></h5>
            <span>Manager</span>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-12 mt-5 mt-md-0">
        <div class="team-member style-2">
          <div class="team-images">
            <img class="img-fluid box-shadow" src="images/team/03.jpg" alt="">
          </div>
          <div class="team-social-icon">
            <ul>
              <li><a href="#"><i class="fab fa-facebook-f"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-google-plus-g"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-linkedin-in"></i></a>
              </li>
            </ul>
          </div>
          <div class="team-description">
            <h5><a href="team-single.html">Charlote Kerry</a></h5>
            <span>Ceo</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--team end-->


<!--testimonial start-->

<section class="pb-0 pos-r" data-bg-img="images/bg/06.png">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div class="owl-carousel" data-items="2" data-md-items="2" data-sm-items="1" data-autoplay="true">
          <div class="item">
            <div class="testimonial style-2">
                  <div class="testimonial-content">
                    <div class="testimonial-quote"><i class="flaticon-left-quote"></i>
                </div>
                    <p>Eeque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt</p>
                  </div>
                  <div class="d-sm-flex align-items-center">
                    <div class="testimonial-img">
                      <img class="img-fluid" src="images/testimonial/01.jpg" alt="">
                    </div>
                    <div class="testimonial-caption">
                      <h5>Alvi Miller</h5>
                      <label>Founder of Agencio</label>
                    </div>
                  </div>
                </div>
          </div>
          <div class="item">
            <div class="testimonial style-2">
                  <div class="testimonial-content">
                    <div class="testimonial-quote"><i class="flaticon-left-quote"></i>
                </div>
                    <p>Reasonable porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam tempora</p>
                  </div>
                  <div class="d-sm-flex align-items-center">
                    <div class="testimonial-img">
                      <img class="img-fluid" src="images/testimonial/02.jpg" alt="">
                    </div>
                    <div class="testimonial-caption">
                      <h5>Albert Jonson</h5>
                      <label>CEO of Agencio</label>
                    </div>
                  </div>
                </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--testimonial end-->


<!--blog start-->

<section>
  <div class="container">
    <div class="row">
      <div class="col-lg-8 col-12">
        <div class="section-title">
          <h6>Blog</h6>
          <h2 class="title">Read Our Latest News</h2>
          <p>Agencio discovering the source behind the ubiquitous filler text. In seeing a sample of lorem ipsum, his interest was piqued by consectetur</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-12">
        <div class="post">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/large/01.jpg" alt="">
          </div>
          <div class="post-desc">
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
            <div class="post-title">
              <h5>We Develop Digital Strategy</h5>
            </div>
            <p>Agencio discovering the source behind the filler In seeing a sample</p> <a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-12">
        <div class="post">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/large/02.jpg" alt="">
          </div>
          <div class="post-desc">
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
            <div class="post-title">
              <h5>These guide Designing work</h5>
            </div>
            <p>Agencio discovering the source behind the filler In seeing a sample</p> <a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-12">
        <div class="post">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/large/03.jpg" alt="">
          </div>
          <div class="post-desc">
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
            <div class="post-title">
              <h5>We're Nominated To Agency</h5>
            </div>
            <p>Agencio discovering the source behind the filler In seeing a sample</p> <a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--blog end-->

</div>

<!--body content end--> 

    </div>
</template>
<script>
// @ is an alias to /src

export default {
  data: function () {
        return {
            hasBanner: false,
            name: "home",
        }
    }
};
</script>